module.exports = __webpack_public_path__ + "img/money.17faf82e.svg";